module.exports = __webpack_public_path__ + "img/2025-02-13b_1.b60cfded.jpg";